import { render, staticRenderFns } from "./TerminalLulls.vue?vue&type=template&id=0f27c6ea&scoped=true&"
import script from "./TerminalLulls.vue?vue&type=script&lang=js&"
export * from "./TerminalLulls.vue?vue&type=script&lang=js&"
import style0 from "./TerminalLulls.vue?vue&type=style&index=0&id=0f27c6ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f27c6ea",
  null
  
)

export default component.exports